import { FC } from 'react';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { DataModalProps } from '@/types';
import { ModalSliceCaPrivacyNoticePrimary } from '../../../../../prismicio-types';
import { CaliforniaPolicyTable, TermsServiceHeroInner } from '@/components';

import styles from './CAPrivacyNotice.module.scss';

const tableTitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.table_title}>{children}</p>,
};

const listTitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.itemTitle}>{children}</p>,
};

const listSubtitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => (
    <p className={styles.itemSubtitle}>{children}</p>
  ),
};

const descriptionComponents: JSXMapSerializer = {
  oList: ({ children }) => <ol>{children}</ol>,
  paragraph: ({ children }) => (
    <p className={styles.descriptionText}>{children}</p>
  ),
};

export const CAPrivacyNotice: FC<
  DataModalProps<ModalSliceCaPrivacyNoticePrimary>
> = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.hero}>
        <TermsServiceHeroInner
          data={{
            last_update_text: data.last_update_text,
            last_update_value: data.last_update_value,
            description: data.description,
            title: data.title,
          }}
          variant="modal"
        />
      </div>
      <div className={styles.tableDescriptionWrapper}>
        <PrismicRichText
          field={data.table_title}
          components={tableTitleComponents}
        />
        <p className={styles.table_description}>{data.table_description}</p>
      </div>
      <div className={styles.table}>
        <CaliforniaPolicyTable
          data={{
            title: [],
            description: null,
            body: data.body,
            head: data.head,
          }}
          variant="modal"
        />
      </div>
      <ul className={styles.list}>
        {data.list.map((item, index) => {
          return (
            <li className={styles.listItem} key={index}>
              <PrismicRichText
                field={item.title}
                components={listTitleComponents}
              />
              {item.subtitle && (
                <PrismicRichText
                  field={item.subtitle}
                  components={listSubtitleComponents}
                />
              )}
              <div className={styles.descriptionWrapper}>
                <PrismicRichText
                  field={item.description}
                  components={descriptionComponents}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
